import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/globals.scss';

import Layout from '@/component/layout';


export default function App({ Component, pageProps }) {


  return (
    <>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </>
  );
}
